import React from 'react';
import css from './css.less';

import ItemWrapper from '@/src/constrains/SalesChannelPreviewPageComponents/OverwriteItemWrapper';
import Section from '@/src/constrains/SalesChannelPreviewPageComponents/SectionContainer';
import ColorPicker from 'src/components/ColorPicker/ColorPicker';

import ProductDraggableDisplay from '@/src/constrains/ProductDraggableDisplay/ImgAndSkuShortDisplay';
import { Select } from 'src/components/Antd';

import {
  EnumCarouselOptions,
  GridOptions,
  optionsToNum,
} from '@/src/pages/SalesChannelContentEditor/common';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
const ProductGridDisplay = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const {
    droppableId,

    onItemDelete,

    onItemSort,
    onStaticChange,
    //To Do Delete Link Temp

    staticData,

    onItemDeleteAll,
    onItemReselect,
    products,
  } = props;

  const { backgroundColor, productToShow } = staticData;

  const _tip = React.useMemo(() => {
    if (productToShow) {
      if (productToShow === EnumCarouselOptions.One) {
        return null;
      } else {
        const number = optionsToNum[productToShow];
        return `${getI18n('general.carouselTipText')} ${number}`;
      }
    }
    return null;
  }, [productToShow]);

  const handleOnItemReselect = (products) => {
    onItemReselect(products);
  };

  const handleOnItemDelete = (index) => {
    onItemDelete(index);
  };

  const handleOnItemSort = (from, to) => {
    onItemSort(from, to);
  };

  const handleOnItemDeleteAll = () => {
    onItemDeleteAll();
  };

  const handleOnBackGroundChange = (data) => {
    if (onStaticChange) onStaticChange({ backgroundColor: data });
  };

  const handleOnProductToShowChange = (data) => {
    if (onStaticChange) onStaticChange({ productToShow: data });
  };

  return (
    <React.Fragment>
      <Section>
        <ItemWrapper
          title={getI18n('general.backgroundColour')}
          containerClassName={css.colorPickerWidth}>
          <ColorPicker
            onChange={handleOnBackGroundChange}
            color={backgroundColor}
            multi
          />
        </ItemWrapper>
        <ItemWrapper
          title={getI18n('general.productstoshowinarow')}
          belowComponentTitle={_tip}>
          <Select
            size='large'
            optionsList={GridOptions}
            value={productToShow}
            onChange={handleOnProductToShowChange}
          />
        </ItemWrapper>
      </Section>
      <ProductDraggableDisplay
        droppableId={droppableId || 'testDrop'}
        data={products}
        onChange={handleOnItemReselect}
        onDelete={handleOnItemDelete}
        onSort={handleOnItemSort}
        onDeleteAll={handleOnItemDeleteAll}
      />
    </React.Fragment>
  );
};
export default ProductGridDisplay;
